export default {
	ALL: 'All',
	MY_TURN: 'My Turn',
	PARTNERS_TURN: "Partner's Turn",
	QUEUED: 'Queued',
	ARCHIVED: 'Archived'
};
